<template>
  <div
    class="teaser-image cell"
    v-if="this.groupitem.image && this.groupitem.image.filepath !== null"
  >
    <generic-link
      v-if="linkUrl"
      :href="linkUrl"
    >
      <AImage
        :img="image"
        :ratio="ratio"
        :alt="alt"
        :title="title"
      />
    </generic-link>
    <div
      v-else
      class="no-image-link"
    >
      <AImage
        :img="image"
        :ratio="ratio"
        :alt="alt"
        :title="title"
      />
    </div>
  </div>
</template>

<script>

export default {
  // Content type uses underscores, linter wants kebab-case!
  // eslint-disable-next-line vue/name-property-casing
  name: 'content-group-image',
  props: {
    orientation: {
      type: String,
      default: ''
    },
    groupitem: {
      type: Object,
      required: true
    }
  },
  computed: {
    alt: function() {
      if (this.image && this.image.data && this.image.data.alt) {
        return this.image.data.alt
      }
      return ''
    },
    title: function() {
      if (this.image && this.image.data && this.image.data.title) {
        return this.image.data.title
      }
      return ''
    },
    image() {
      if (this.groupitem && this.groupitem.image) {
        return this.groupitem.image
      }
      return null
    },
    linkUrl() {
      return this.groupitem.link ? this.groupitem.link.url : null
    },
    linkTitle() {
      return this.groupitem.link ? this.groupitem.link.title : null
    },
    ratio() {
      if (this.orientation === 'portrait') {
        return '3-4'
      }
      return '16-9'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

@include media-breakpoint-down(sm) {
  .teaser-image {
    width: 100%;
    margin-bottom: 1em;
  }
}

@include media-breakpoint-up(md) {
  .portrait {
    .teaser-image {
      width: 25%;
    }
  }

  .landscape {
    .teaser-image {
      width: 40%;
    }
  }
}

//cell structure
.cell:nth-child(1).teaser-content {
  margin-top: 0em;
  width: 100%;
  padding: 0em;
}

.cell:nth-child(2),
.cell:not(:nth-child(1)) {
  padding-left: 0em;
  @include media-breakpoint-up(sm) {
    padding-left: 2em;
  }
}
.right {
  .cell:nth-child(2),
  .cell:not(:nth-child(1)) {
    padding-left: 0em;
    @include media-breakpoint-up(sm) {
      padding-right: 2em;
    }
  }
}

</style>
